import { render, staticRenderFns } from "./belt.vue?vue&type=template&id=683f1654&scoped=true&"
import script from "./belt.vue?vue&type=script&lang=js&"
export * from "./belt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f1654",
  null
  
)

export default component.exports